import { PAYMENT_LABELS, STATUS_LABELS } from "@/lib/api";

const PAY_COLORS = {
  unpaid: "bg-[var(--alt)] text-[var(--ink-2)]",
  deposit_paid: "bg-[#FFF3E0] text-[#E65100]",
  part_paid: "bg-[#FFF3E0] text-[#E65100]",
  paid_in_full: "bg-[#E8F5E9] text-[#1B5E20]",
  sponsored: "bg-[#E3F2FD] text-[#0D47A1]",
  payment_plan_active: "bg-[#E3F2FD] text-[#0D47A1]",
  overdue: "bg-[#FFEBEE] text-[#B71C1C]",
  refunded: "bg-[var(--alt)] text-[var(--ink-2)]",
  comped: "bg-[#E8F5E9] text-[#1B5E20]",
};
const STATUS_COLORS = {
  applied: "bg-[var(--alt)] text-[var(--ink-2)]",
  approved: "bg-[#E3F2FD] text-[#0D47A1]",
  waitlisted: "bg-[#FFF3E0] text-[#E65100]",
  rejected: "bg-[#FFEBEE] text-[#B71C1C]",
  enrolled: "bg-[#E8F5E9] text-[#1B5E20]",
  completed: "bg-[var(--ink)] text-white",
};

export function PaymentBadge({ status }) {
  return <span data-testid={`payment-badge-${status}`} className={`inline-block text-[11px] font-semibold px-2.5 py-1 ${PAY_COLORS[status] || PAY_COLORS.unpaid}`}>{PAYMENT_LABELS[status] || status}</span>;
}
export function StatusBadge({ status }) {
  return <span data-testid={`status-badge-${status}`} className={`inline-block text-[11px] font-semibold px-2.5 py-1 ${STATUS_COLORS[status] || STATUS_COLORS.applied}`}>{STATUS_LABELS[status] || status}</span>;
}
